export const summaryRows: Array<[string, string]> = [
  ['9 tomos completos', 'Fundamentos, patrimonio, documentación, conservación, museografía, educación, gestión, inclusión e innovación'],
  ['5 bonos estratégicos', 'Proyectos, recursos, actividades, evaluaciones y proyecto integrador'],
  ['150 actividades museológicas listas', 'Formuladas y listas para adaptar a cualquier museo argentino'],
  ['Banco completo de casos prácticos', '100 situaciones reales para analizar y resolver como profesional'],
  ['200 preguntas y debates', 'Para desarrollar pensamiento crítico y argumentación profesional'],
  ['Sistema completo de evaluación', 'Rúbricas, criterios de corrección y respuestas orientativas docentes'],
  ['Proyecto final integrador', 'Construí un museo desde cero con plan de apertura de 90 días'],
  ['Plantillas editables', 'Proyectos, presupuestos, documentación y mediación'],
  ['Casos reales resueltos', 'Con datos del campo museológico argentino'],
  ['Normativa internacional y contexto argentino', 'Estándares aplicados a la realidad local'],
  ['Acceso inmediato', 'Descarga directa en menos de 5 minutos'],
  ['Acceso de por vida y actualizaciones', 'Sin costos adicionales'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios'],
];
